import { atom, selector } from 'recoil';
import { Product, ProductId } from '../utils/Product';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export type CartItem = { product: Product, cartQuantity: number }
export type CartState = Record<ProductId, CartItem>;

const cartAtom = atom<CartState>({
  key: 'cartAtom',
  default: {} as CartState,
  // eslint-disable-next-line camelcase
  effects_UNSTABLE: [persistAtom],
});

const cartState = selector({
  key: 'cartState',
  get: ({ get }) => ({
    cartContents: get(cartAtom),
    cartTotal: Object.values(get(cartAtom))
      .map(item => item.cartQuantity * item.product.price)
      .reduce((previousValue, currentValue) => previousValue + currentValue, 0),
    cartUniqueItemCount: Object.keys(get(cartAtom)).length,
    cartItemCount: Object.values(get(cartAtom))
      .map(item => item.cartQuantity)
      .reduce((previousValue, currentValue) => previousValue + currentValue, 0),
  }),
});

export {
  cartAtom,
  cartState,
};
